import { render, staticRenderFns } from "./RewardsScreen.vue?vue&type=template&id=4291d936&scoped=true"
import script from "./RewardsScreen.vue?vue&type=script&lang=js"
export * from "./RewardsScreen.vue?vue&type=script&lang=js"
import style0 from "./RewardsScreen.vue?vue&type=style&index=0&id=4291d936&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4291d936",
  null
  
)

export default component.exports